export default "__VITE_ASSET__BSOdd0Oc__"